import { motion } from "framer-motion";
import { ASSETS } from "@/lib/content";

export const MeetBast = () => {
  return (
    <section id="meet-bast" className="relative py-24 sm:py-32">
      <div className="mx-auto max-w-3xl px-6 text-center lg:px-8">
        <motion.img
          src={ASSETS.appIcon}
          alt="Bast the tabby"
          initial={{ opacity: 0, scale: 0.8 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="mx-auto h-24 w-24 rounded-[1.4rem] shadow-2xl shadow-emerald-900/20"
        />
        <motion.h2
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.1 }}
          className="mt-8 font-heading text-3xl font-extrabold leading-tight tracking-tight text-gray-900 sm:text-4xl"
        >
          Meet Bast. She has opinions and excellent taste.
        </motion.h2>
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.18 }}
          className="mt-6 text-lg leading-relaxed text-gray-600"
        >
          A grey tabby who runs your Purrse and helps you spend on what actually lights you up —
          while gently minding the rest. No guilt. No tiny red warnings shouting at you on a
          Tuesday. Built with care for anyone tired of budgeting tools that make money feel like a
          chore or a confession.
        </motion.p>
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.26 }}
          className="mt-8 font-heading text-2xl font-bold italic text-emerald-500"
        >
          Download Purrse. Pick your three. Let Bast handle the side eye.
        </motion.p>
      </div>
    </section>
  );
};
